<template>
  <tm-list class="tm-faq">
    <slot />
  </tm-list>
</template>

<script setup lang="ts">
import TmList from '@/components/shared/TmList.vue'
import { useFaqItems } from '@/composition/faq'

useFaqItems()
</script>
